"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _constants = require("./constants");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = "@font-face {\n  font-family: 'OpenSansRegular';\n  src: url(\"../assets/font/OpenSans-latin-normal.woff2\") format(\"woff2\"); }\n\n.category {\n  padding-left: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  font-weight: bold;\n  letter-spacing: 1px;\n  font-family: \"OpenSansRegular\";\n  background-color: #ececec;\n  cursor: default; }\n\n.options-container {\n  max-height: 20rem;\n  border: 0.0625rem solid #067fdb;\n  padding-top: 0.25rem;\n  padding-bottom: 0.25rem;\n  box-sizing: border-box;\n  overflow: auto;\n  border-radius: 0.1875rem; }\n\n.option {\n  display: flex;\n  align-items: center;\n  padding-left: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  box-sizing: border-box;\n  cursor: pointer; }\n  .option:hover {\n    background: #e0e0e0; }\n  .option.grouped {\n    padding-left: 2rem; }\n\n.selected-option {\n  background-color: #d0e2ff; }\n\n.highlight-option {\n  background-color: #0561a7; }\n\n.option-with-label-sublabel {\n  height: 3.5rem; }\n\n.option-with-label {\n  height: 2.5rem; }\n\n.option-icon {\n  display: flex;\n  align-items: center;\n  margin-right: 1rem; }\n\n.option-icon-large {\n  width: 2.5rem;\n  height: 2.5rem; }\n\n.option-icon-small {\n  width: 1.5rem;\n  height: 1.5rem; }\n\n.option-label {\n  display: block;\n  height: 1.1875rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #393939;\n  font-size: 0.875rem;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis; }\n  .option-label:hover {\n    color: #393939; }\n\n.highlight-option-label {\n  color: #ffffff; }\n\n.disabled-option-label {\n  color: #c6c6c6; }\n\n.option-label-with-sublabel {\n  margin-bottom: 0.25rem; }\n\n.option-label-alone {\n  margin-top: 0.625rem;\n  margin-bottom: 0.6875rem; }\n\n.option-sublabel {\n  display: flex;\n  align-items: center;\n  height: 1.0625rem;\n  font-family: \"OpenSansRegular\";\n  letter-spacing: 0.02rem;\n  color: #6f6f6f;\n  font-size: 0.75rem; }\n\n.option-label-sublabel-container {\n  display: flex;\n  flex-direction: column;\n  width: 100%; }\n\n.separator {\n  margin-top: 0.25rem;\n  margin-bottom: 0.25rem; }\n";
  var fileName = "container_container";
  var element = document.querySelector("style[data-sass-component='container_container']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var MenuOptions = function MenuOptions(_ref) {
  var options = _ref.options,
      onChange = _ref.onChange,
      getOptionIcon = _ref.getOptionIcon,
      getOptionLabel = _ref.getOptionLabel,
      getOptionSublabel = _ref.getOptionSublabel,
      width = _ref.width,
      containerDimension = _ref.containerDimension,
      value = _ref.value,
      portalContainerId = _ref.portalContainerId,
      _ref$disablePortal = _ref.disablePortal,
      disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
      groupPropertyName = _ref.groupPropertyName;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      optionsContainerHeight = _useState2[0],
      setOptionsContainerHeight = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = _slicedToArray(_useState3, 2),
      optionsContainerWidth = _useState4[0],
      setOptionsContainerWidth = _useState4[1];

  var vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
  var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

  var _useState5 = (0, _react.useState)(document.createElement("div")),
      _useState6 = _slicedToArray(_useState5, 1),
      optionsEl = _useState6[0];

  optionsEl.id = "".concat(portalContainerId);
  optionsEl.style.zIndex = 3000;
  optionsEl.style.backgroundColor = "white";
  var bottomWidth, rightWidth, left, top;

  if (!disablePortal) {
    optionsEl.style.position = "absolute";
    optionsEl.style.top = 0;
    optionsEl.style.left = 0;

    if (containerDimension) {
      bottomWidth = "".concat(vh - containerDimension.bottom);
      rightWidth = "".concat(vw - containerDimension.left);
      left = "".concat(rightWidth) < optionsContainerWidth ? containerDimension.right - optionsContainerWidth : containerDimension.left;
      top = "".concat(bottomWidth) < optionsContainerHeight ? containerDimension.top - optionsContainerHeight : containerDimension.bottom;
    }

    optionsEl.style.transform = containerDimension && "translate3d(".concat(left + window.pageXOffset, "px,").concat(top + window.pageYOffset, "px,0)");
  }

  (0, _react.useEffect)(function () {
    if (!disablePortal) {
      var bodyElement = document.getElementsByTagName("body")[0];
      bodyElement.appendChild(optionsEl);
      var optionsElHeight = optionsEl.getBoundingClientRect().height;
      var optionsElWidth = optionsEl.getBoundingClientRect().width;
      setOptionsContainerHeight(optionsElHeight);
      setOptionsContainerWidth(optionsElWidth);
      return function () {
        return bodyElement.removeChild(optionsEl);
      };
    }
  }, [optionsEl, options]);
  var optionsListProps = {
    options: options,
    getOptionLabel: getOptionLabel,
    getOptionSublabel: getOptionSublabel,
    getOptionIcon: getOptionIcon,
    value: value,
    onChange: onChange,
    width: width,
    disablePortal: disablePortal,
    groupPropertyName: groupPropertyName
  };
  return disablePortal ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/_react.default.createElement(OptionsList, optionsListProps)) : /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(OptionsList, optionsListProps), optionsEl);
};

var OptionsList = function OptionsList(_ref2) {
  var _labelClasses, _optionClasses, _optionIconClasses;

  var options = _ref2.options,
      getOptionLabel = _ref2.getOptionLabel,
      getOptionSublabel = _ref2.getOptionSublabel,
      getOptionIcon = _ref2.getOptionIcon,
      value = _ref2.value,
      onChange = _ref2.onChange,
      width = _ref2.width,
      disablePortal = _ref2.disablePortal,
      groupPropertyName = _ref2.groupPropertyName;

  var isOptionSelected = function isOptionSelected(item) {
    var isOptionSelected = false;

    for (var i in value) {
      if (value[i] === item) {
        isOptionSelected = true;
        break;
      }
    }

    return isOptionSelected;
  };

  var isOptionDisabled = function isOptionDisabled(item) {
    return Boolean(item.isDisabled);
  };

  var labelClasses = (_labelClasses = {}, _defineProperty(_labelClasses, _constants.classes.optionLabel, true), _defineProperty(_labelClasses, _constants.classes.optionLabelWithSublabel, Boolean(getOptionLabel) && Boolean(getOptionSublabel)), _defineProperty(_labelClasses, _constants.classes.optionLabelAlone, Boolean(getOptionLabel) && !Boolean(getOptionSublabel) && !Boolean(getOptionIcon)), _labelClasses);
  var optionClasses = (_optionClasses = {}, _defineProperty(_optionClasses, _constants.classes.option, true), _defineProperty(_optionClasses, _constants.classes.optionWithLabelSublabel, Boolean(getOptionLabel) && Boolean(getOptionSublabel) && !Boolean(getOptionIcon)), _defineProperty(_optionClasses, _constants.classes.optionWithLabel, Boolean(getOptionLabel) && !Boolean(getOptionSublabel) && !Boolean(getOptionIcon)), _defineProperty(_optionClasses, _constants.classes.grouped, !!groupPropertyName), _optionClasses);
  var optionIconClasses = (_optionIconClasses = {}, _defineProperty(_optionIconClasses, _constants.classes.optionIcon, true), _defineProperty(_optionIconClasses, _constants.classes.optionIconLarge, Boolean(getOptionIcon) && Boolean(getOptionLabel) && Boolean(getOptionSublabel)), _defineProperty(_optionIconClasses, _constants.classes.optionIconSmall, Boolean(getOptionLabel) && !Boolean(getOptionSublabel) && Boolean(getOptionIcon)), _optionIconClasses);

  var optionContainerClasses = _defineProperty({}, _constants.classes.optionsContainer, true);

  var optionsByCategories = (0, _react.useMemo)(function () {
    if (!groupPropertyName) {
      return {
        _default: options
      };
    }

    var result = [];
    options.forEach(function (option) {
      if (!result[option[groupPropertyName]]) {
        result[option[groupPropertyName]] = [option];
      } else {
        result[option[groupPropertyName]].push(option);
      }
    });
    return result;
  }, [options]);

  if (!Object.entries(optionsByCategories).length) {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_objectSpread({}, optionContainerClasses)),
    style: _objectSpread({
      width: width
    }, disablePortal ? {
      backgroundColor: "white",
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 30000
    } : {})
  }, Object.entries(optionsByCategories).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        category = _ref4[0],
        options = _ref4[1];

    return /*#__PURE__*/_react.default.createElement("div", {
      key: category
    }, category && category !== "_default" && /*#__PURE__*/_react.default.createElement("div", {
      className: _constants.classes.category
    }, category), options && Boolean(options.length) && options.map(function (item, index) {
      var _objectSpread2, _objectSpread3;

      return Boolean(item.separator) ? /*#__PURE__*/_react.default.createElement("hr", {
        role: _constants.optionRole,
        key: "separator-".concat(index),
        className: _constants.classes.separator
      }) : /*#__PURE__*/_react.default.createElement("div", {
        tabIndex: _constants.defaultTabIndex,
        role: _constants.optionRole,
        title: getOptionLabel(item),
        className: (0, _classnames.default)(_objectSpread(_objectSpread({}, optionClasses), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, _constants.classes.selectedOption, isOptionSelected(item)), _defineProperty(_objectSpread2, _constants.classes.highlightOption, item.highlight), _objectSpread2))),
        onMouseDown: function onMouseDown(event) {
          return event.preventDefault();
        },
        key: "filter-option-".concat(index),
        onClick: function onClick(event) {
          return onChange(event, item);
        }
      }, getOptionIcon && /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_objectSpread({}, optionIconClasses))
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: getOptionIcon(item),
        alt: getOptionLabel(item)
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.optionLabelSublabelContainer
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(_objectSpread(_objectSpread({}, labelClasses), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, _constants.classes.disabledOptionLabel, isOptionDisabled(item)), _defineProperty(_objectSpread3, _constants.classes.highlightOptionLabel, item.highlight), _objectSpread3)))
      }, getOptionLabel(item)), getOptionSublabel && /*#__PURE__*/_react.default.createElement("div", {
        className: _constants.classes.optionSublabel
      }, getOptionSublabel(item))));
    }));
  }));
};

MenuOptions.propTypes = {
  options: _propTypes.default.array.isRequired,
  onChange: _propTypes.default.func.isRequired,
  getOptionIcon: _propTypes.default.func,
  getOptionLabel: _propTypes.default.func.isRequired,
  getOptionSublabel: _propTypes.default.func,
  width: _propTypes.default.string,
  containerDimension: _propTypes.default.object.isRequired,
  value: _propTypes.default.array,
  portalContainerId: _propTypes.default.string.isRequired,
  disablePortal: _propTypes.default.bool,
  groupPropertyName: _propTypes.default.string
};
var _default = MenuOptions;
exports.default = _default;